import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import style from "css/signup/signupExpired.module.css";
import SEOMeta from "component/app/SEOMeta";

function SignUpExpired() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const code = location.state?.code;

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!code) {
      navigate("/signup", { replace: true });
    }
  }, [code, navigate]);

  if (!code) return null;

  const handleResend = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/auth/resendMail`,
        { CODE: code },
      );
      const newEmail = res.data?.EMAIL;
      if (!newEmail) {
        message.error(t("signup.expired.invalidResponse"));
        return;
      }
      message.success(t("signup.expired.resendSuccess"));
      navigate("/signup/verify", {
        state: { email: newEmail },
        replace: true,
      });
    } catch (err) {
      const data = err?.response?.data;
      const errCode =
        typeof data === "string" ? data : data?.userMsg || data?.UserMsg;
      if (errCode === "DUPLICATED_EMAIL") {
        Modal.info({
          icon: null,
          title: (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 16,
              }}
            >
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/signup/email_expired.svg`}
                alt=""
                style={{ width: 22, height: 22, flexShrink: 0 }}
              />
              {t("signup.expired.alreadyRegisteredTitle")}
            </span>
          ),
          content: t("signup.expired.alreadyRegisteredContent"),
          centered: true,
          okText: t("signup.expired.ok"),
          okButtonProps: {
            style: {
              background:
                "linear-gradient(to right, #ff402b 0%, #ffb12b 100%)",
              border: "none",
              boxShadow: "none",
              color: "#fff",
            },
          },
          onOk: () =>
            navigate("/", {
              replace: true,
            }),
        });
        return;
      }
      if (errCode === "INVALID_AUTHCODE") {
        message.error(t("signup.expired.invalidCode"));
        navigate("/signup", { replace: true });
        return;
      }
      message.error(t("signup.expired.tempError"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={style.page}>
      <SEOMeta
        title={t("signup.expired.seo.title")}
        description={t("signup.expired.seo.description")}
        keywords={t("signup.expired.seo.keywords")}
      />
      <div className={style.content}>
        <img
          className={style.icon}
          src={`${process.env.REACT_APP_CLIENT_URL}img/signup/email_expired.svg`}
          alt=""
        />
        <h1 className={style.title}>{t("signup.expired.title")}</h1>
        <p className={style.message}>
          <Trans
            i18nKey="signup.expired.message"
            components={{ br: <br /> }}
          />
        </p>
        <button
          type="button"
          className={style.resendBtn}
          onClick={handleResend}
          disabled={submitting}
        >
          {t("signup.expired.resend")}
        </button>
      </div>
    </div>
  );
}

export default SignUpExpired;
